import React from 'react';
import { Logo } from './Logo';

const LINKS = {
  Services: ['Web & App Dev', 'Digital Marketing', 'AI Solutions', 'Automation', 'IT Consulting'],
  Company: ['About', 'Process', 'Work', 'FAQ'],
  Social: ['LinkedIn', 'Instagram', 'X / Twitter', 'Dribbble'],
};

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 px-6 lg:px-12 pt-20 pb-10 bg-black">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 flex flex-col gap-6">
            <Logo size="md" />
            <p className="font-manrope text-sm text-white/55 max-w-md leading-relaxed">
              ELEVA Digital — a modern digital solutions agency. We elevate businesses through
              innovation, creativity, and smart digital technology.
            </p>
          </div>

          {Object.entries(LINKS).map(([title, items]) => (
            <div key={title} className="lg:col-span-2 flex flex-col gap-4">
              <h4 className="font-manrope text-xs uppercase tracking-[0.25em] text-white/40">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {items.map((item) => (
                  <li key={item}>
                    <a
                      href="#"
                      data-testid={`footer-link-${item.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
                      className="font-manrope text-sm text-white/70 hover:text-brand-primary transition-colors"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Mega outline word */}
        <div className="mt-20 mb-10 overflow-hidden">
          <span className="font-outfit font-black tracking-tighter outline-text text-[22vw] lg:text-[16vw] leading-none block whitespace-nowrap">
            ELEVA / DIGITAL
          </span>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
          <span className="font-manrope text-xs text-white/40">
            © {year} ELEVA Digital. All rights reserved.
          </span>
          <div className="flex items-center gap-6">
            <a href="#" data-testid="footer-privacy" className="font-manrope text-xs text-white/40 hover:text-white transition-colors">Privacy</a>
            <a href="#" data-testid="footer-terms" className="font-manrope text-xs text-white/40 hover:text-white transition-colors">Terms</a>
            <a href="mailto:info@elevadigital.com.au" data-testid="footer-mailto" className="font-manrope text-xs text-white/40 hover:text-brand-primary transition-colors">
              info@elevadigital.com.au
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
